import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganizacion } from '../context/OrganizacionContext';

const LoginUnificado = () => {
  const navigate = useNavigate();
  const { config, logoUrl } = useOrganizacion();

  const handleUserTypeSelection = (userType) => {
    // Redirigir según el tipo de usuario seleccionado
    switch (userType) {
      case 'evaluacion':
        // Tanto trabajadores como líderes van al mismo login OTP
        navigate('/login-otp');
        break;
      case 'administrador':
      case 'admin':
        navigate('/login-dashboard');
        break;
      default:
        break;
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-2xl">
        <div>
          {/* Logo de la organización */}
          {logoUrl && config.mostrar_logo && (
            <div className="flex justify-center mb-6">
              <img
                src={logoUrl}
                alt={config.nombre_organizacion || 'Logo'}
                className="h-20 w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          )}
          
          <h2 
            className="mt-6 text-center text-3xl font-extrabold"
            style={{ color: config.color_primario }}
          >
            {config.nombre_organizacion || 'Sistema de Evaluación 360°'}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Selecciona tu tipo de usuario para continuar
          </p>
        </div>

        <div className="mt-8 space-y-4">
          {/* Opción Evaluación (Trabajadores y Líderes) */}
          <button
            onClick={() => handleUserTypeSelection('evaluacion')}
            className="group relative w-full flex justify-center py-4 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 transform hover:scale-105"
          >
            <div className="flex items-center">
              <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div className="text-left">
                <div className="font-semibold">Evaluación</div>
                <div className="text-xs text-blue-100">Evaluar a mi equipo o líder</div>
              </div>
            </div>
          </button>

          {/* Opción Administrador */}
          <button
            onClick={() => handleUserTypeSelection('administrador')}
            className="group relative w-full flex justify-center py-4 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-200 transform hover:scale-105"
          >
            <div className="flex items-center">
              <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37-2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <div className="text-left">
                <div className="font-semibold">Administrador</div>
                <div className="text-xs text-purple-100">Panel de administración</div>
              </div>
            </div>
          </button>
        </div>

        {/* Información adicional */}
        <div className="mt-8 text-center">
          <div className="text-xs text-gray-500">
            <p className="mb-2">¿Necesitas ayuda?</p>
            <p>Contacta al administrador del sistema</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginUnificado;